import "./MenuScreen.css";

interface ModeScreenProps {
  onSelectGeography: () => void;
  onSelectMath: () => void;
}

export function ModeScreen({ onSelectGeography, onSelectMath }: ModeScreenProps) {
  return (
    <div className="MenuScreen">
      <div className="MenuCard">
        <div className="MenuTitle">Platforma edukacyjna</div>
        <div className="MenuSubtitle">Wybierz temat nauki</div>
        <div className="MenuActions">
          <button
            className="MenuButton"
            type="button"
            onClick={onSelectGeography}
          >
            Geografia — mapy
          </button>
          <button
            className="MenuButton is-secondary"
            type="button"
            onClick={onSelectMath}
          >
            Matematyka — działania
          </button>
        </div>
      </div>
      <div className="MenuBackdrop" />
    </div>
  );
}
